export let employeeChoices = [];

export const createObject = (piece, task) => {
    const selectedPiece = getPieceById(piece.piece_id)

    if (isNewPiece(selectedPiece)) {
        selectNewPiece(piece, task);
    } else {
        const taskIndex = getTaskIndex(selectedPiece, task);

        if (isTaskAlreadySelected(taskIndex)) {
            unselectTask(selectedPiece, taskIndex);

            if (noTasksLeftInPiece(selectedPiece)) {
                unselectPiece(piece);
            }
        } else {
            selectTask(selectedPiece, task);
        };
    };
};

const isNewPiece = (selectedPiece) => selectedPiece === undefined;

const selectNewPiece = (piece, task) => {
    employeeChoices.push(newPiece(piece, task));
};

const newPiece = (piece, task) => {
    return {
        piece_id: piece.piece_id,
        project_key: piece.project_key,
        start_date: piece.start_date,
        end_date: piece.end_date,
        name: piece.name,
        tasks: [{
            name: task.name,
            project_key: task.project_key,
            task_id: task.task_id,
        }],
    };
};

const getPieceById = (piece_id) => {
    return employeeChoices.find(el => el.piece_id === piece_id);
}

const getTaskIndex = (selectedPiece, task) => {
    return selectedPiece.tasks.findIndex(el => el.task_id === task.task_id);
};

const isTaskAlreadySelected = (taskIndex) => taskIndex !== -1;

const unselectTask = (selectedPiece, taskIndex) => {
    selectedPiece.tasks.splice(taskIndex, 1);
};

const noTasksLeftInPiece = (selectedPiece) => selectedPiece.tasks.length === 0;

export const unselectPiece = (piece) => {
    const pieceIndex = employeeChoices.findIndex(el => el.piece_id === piece.piece_id);

    if (pieceIndex !== -1) {
        employeeChoices.splice(pieceIndex, 1);
    }
};

const selectTask = (selectedPiece, task) => {
    selectedPiece.tasks.push({
        name: task.name,
        project_key: task.project_key,
        task_id: task.task_id,
    });
};
